import type { ChangeEvent } from 'react';

export const COURSE_HOLE_COUNT = 9;

export function holeNumbers(count: number = COURSE_HOLE_COUNT): number[] {
  return Array.from({ length: count }, (_value, index) => index + 1);
}

export function normalizeHoleValues(
  values: unknown,
  fallbackValue: number,
  count: number = COURSE_HOLE_COUNT,
): number[] {
  return holeNumbers(count).map((hole) => {
    const raw = Array.isArray(values) ? values[hole - 1] : undefined;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : fallbackValue;
  });
}

export function sumHolePars(holePars: number[]): number {
  return holePars.reduce((sum, value) => sum + (Number.isFinite(value) ? value : 0), 0);
}

interface CourseScorecardGridProps {
  holePars: number[];
  holeHandicaps: number[];
  disabled?: boolean;
  onParChange: (holeIndex: number, value: number) => void;
  onHandicapChange: (holeIndex: number, value: number) => void;
}

export function CourseScorecardGrid({
  holePars,
  holeHandicaps,
  disabled = false,
  onParChange,
  onHandicapChange,
}: CourseScorecardGridProps) {
  const holes = holeNumbers();

  const parseValue = (event: ChangeEvent<HTMLInputElement>) => Number(event.target.value);

  return (
    <div className="scorecard-wrap">
      <table className="scorecard-grid">
        <tbody>
          <tr>
            <th>Hole</th>
            {holes.map((hole) => (
              <td key={`hole-${hole}`}>{hole}</td>
            ))}
          </tr>
          <tr>
            <th>Par</th>
            {holes.map((hole, index) => (
              <td key={`par-${hole}`}>
                <input
                  className="scorecard-input"
                  type="number"
                  min={1}
                  max={9}
                  step={1}
                  disabled={disabled}
                  value={holePars[index] ?? 4}
                  onChange={(event) => onParChange(index, parseValue(event))}
                />
              </td>
            ))}
          </tr>
          <tr>
            <th>Handicap</th>
            {holes.map((hole, index) => (
              <td key={`handicap-${hole}`}>
                <input
                  className="scorecard-input"
                  type="number"
                  min={1}
                  max={COURSE_HOLE_COUNT}
                  step={1}
                  disabled={disabled}
                  value={holeHandicaps[index] ?? 1}
                  onChange={(event) => onHandicapChange(index, parseValue(event))}
                />
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
